import styled from 'styled-components';
import { QuestionTitle } from '../QuestionTitle';
import { Author } from '../Author';

/* eslint-disable */
export const QuestionBody = styled.div`
  position: relative;
  margin-bottom: 24px;

  ${/* sc-sel */ QuestionTitle} {
    padding-bottom: 27px;
  }

  ${/* sc-sel */ Author} {
    &:not(:last-child) {
      padding-bottom: 24px;
    }

    &:last-child {
      padding-bottom: 0;
    }
  }
`;
/* eslint-enable */
